import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { postData, fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import CircularProgress from '@mui/material/CircularProgress';
import DoneIcon from '@mui/icons-material/Done';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import CopyrightIcon from '@mui/icons-material/Copyright';
import '../shared.css';

const ItemCreate = () => {
  const history = useHistory();
  const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const [name, setName]                       = useState('');
  const [code, setCode]                       = useState('');
  const [pf, setPF]                           = useState('');
  const [isg, setISG]                         = useState('');
  const [purchaseRate, setPurchaseRate]       = useState('0');
  const [mrp, setMRP]                         = useState('0');
  const [hsncode, setHSNCode]                 = useState('');
  const [gstRate, setGSTRate]                 = useState('0');
  const [discountPercentage, setDiscountPercentage] = useState('0');
  const [isExcluding, setIsExcluding]         = useState(false);

  const [selectedCategory, setSelectedCategory]       = useState('');
  const [selectedPGCategory, setSelectedPGCategory]   = useState('');
  const [selectedItemGroup, setSelectedItemGroup]     = useState('');

  const [dropdownCategoryOptions, setDropdownCategoryOptions]       = useState([]);
  const [dropdownPGCategoryOptions, setDropdownPGCategoryOptions]   = useState([]);
  const [dropdownItemGroupOptions, setDropdownItemGroupOptions]     = useState([]);

  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
  }, [isAuthenticated, companyId, branchId, token, logout]);

  useEffect(() => {
    fetchDropdownCategoryOptions();
    fetchDropdownPGCategoryOptions();
    fetchDropdownItemGroupOptions();
  }, []);

  const fetchDropdownCategoryOptions = () => {
    fetchData('ItemApi', `/Category/${companyId}`, token)
      .then(response => setDropdownCategoryOptions(response.response_data))
      .catch(err => console.error('Error fetching Category dropdown:', err));
  };

  const fetchDropdownPGCategoryOptions = () => {
    fetchData('ItemApi', `/PGCategory/${companyId}`, token)
      .then(response => setDropdownPGCategoryOptions(response.response_data))
      .catch(err => console.error('Error fetching PG Category dropdown:', err));
  };

  const fetchDropdownItemGroupOptions = () => {
    fetchData('ItemApi', `/ItemGroup/${companyId}`, token)
      .then(response => setDropdownItemGroupOptions(response.response_data))
      .catch(err => console.error('Error fetching Item Group dropdown:', err));
  };

  const submitData = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (!name) {
      setErrorMessage('All fields are required!');
      setIsLoading(false);
      return;
    }

    const CreateData = {
      Code: code,
      Name: name,
      PF: pf,
      ISG: isg,
      PurchaseRate: purchaseRate,
      MRP: mrp,
      HSNCode: hsncode,
      GSTRate: gstRate,
      DiscountPercentage: discountPercentage,
      IsExcluding: isExcluding,
      CategoryId: selectedCategory,
      PGCategoryId: selectedPGCategory,
      ItemGroupId: selectedItemGroup,
      CreatedBy: userId,
      CompanyId: companyId,
      CreatedDate: new Date(),
    };

    postData('ItemApi', CreateData, token)
      .then(() => {
        setSuccessMessage('Item Created successfully!');
        setErrorMessage('');
        history.push('/ItemIndex');
      })
      .catch((error) => {
        console.error('Item Create error:', error);
        setIsLoading(false);
      });
  };

  return (
    <div className="pg-container">
      {/* ── Header ── */}
      <div className="pg-header">
        <h5 className="pg-title">Item Create</h5>
        <div className="pg-header-actions">
          <div className="pg-action-row">
            <button className="pg-btn pg-btn-success" onClick={submitData} disabled={isLoading}>
              <DoneIcon /> {isLoading ? <CircularProgress size={14} color="inherit" /> : 'Save'}
            </button>
            <Link to="/ItemIndex" className="pg-btn pg-btn-danger">
              <ReplyAllIcon /> Back to List
            </Link>
          </div>
        </div>
      </div>

      {/* ── Alerts ── */}
      {errorMessage && <div className="pg-alert pg-alert-error">{errorMessage}</div>}
      {successMessage && <div className="pg-alert pg-alert-success">{successMessage}</div>}

      {/* ── Form ── */}
      <form onSubmit={submitData}>
        <div className="pg-card">
          <div className="pg-form-grid pg-form-grid-2">
            <div className="pg-field">
              <label className="pg-label">Item Name <span className="req">*</span></label>
              <input className="pg-input" value={name} onChange={e => setName(e.target.value)} placeholder="Enter Name" />
            </div>
            <div className="pg-field">
              <label className="pg-label">Item Code <span className="req">*</span></label>
              <input className="pg-input" value={code} onChange={e => setCode(e.target.value)} placeholder="Enter Code" />
            </div>
          </div>

          <div className="pg-form-grid pg-form-grid-4">
            <div className="pg-field">
              <label className="pg-label">Category <span className="req">*</span></label>
              <select className="pg-select" value={selectedCategory} onChange={e => setSelectedCategory(e.target.value)}>
                <option value="">Select Category</option>
                {dropdownCategoryOptions.map(cat => (
                  <option key={cat.Id} value={cat.Id}>{cat.Name}</option>
                ))}
              </select>
            </div>
            <div className="pg-field">
              <label className="pg-label">PG Category <span className="req">*</span></label>
              <select className="pg-select" value={selectedPGCategory} onChange={e => setSelectedPGCategory(e.target.value)}>
                <option value="">Select PG Category</option>
                {dropdownPGCategoryOptions.map(cat => (
                  <option key={cat.Id} value={cat.Id}>{cat.Name}</option>
                ))}
              </select>
            </div>
            <div className="pg-field">
              <label className="pg-label">Item Group <span className="req">*</span></label>
              <select className="pg-select" value={selectedItemGroup} onChange={e => setSelectedItemGroup(e.target.value)}>
                <option value="">Select Item Group</option>
                {dropdownItemGroupOptions.map(cat => (
                  <option key={cat.Id} value={cat.Id}>{cat.Name}</option>
                ))}
              </select>
            </div>
            <div className="pg-field">
              <label className="pg-label">PF</label>
              <input className="pg-input" value={pf} onChange={e => setPF(e.target.value)} placeholder="Enter PF" />
            </div>
          </div>

          <div className="pg-form-grid pg-form-grid-4">
            <div className="pg-field">
              <label className="pg-label">ISG</label>
              <input className="pg-input" value={isg} onChange={e => setISG(e.target.value)} placeholder="Enter ISG" />
            </div>
            <div className="pg-field">
              <label className="pg-label">Purchase Rate</label>
              <input className="pg-input text-right" value={purchaseRate} onChange={e => setPurchaseRate(e.target.value)} placeholder="0.00" />
            </div>
            <div className="pg-field">
              <label className="pg-label">MRP</label>
              <input className="pg-input text-right" value={mrp} onChange={e => setMRP(e.target.value)} placeholder="0.00" />
            </div>
            <div className="pg-field">
              <label className="pg-label">Discount %</label>
              <input className="pg-input text-right" value={discountPercentage} onChange={e => setDiscountPercentage(e.target.value)} placeholder="0.00" />
            </div>
          </div>

          <div className="pg-form-grid pg-form-grid-4">
            <div className="pg-field">
              <label className="pg-label">GST Rate</label>
              <input className="pg-input text-right" value={gstRate} onChange={e => setGSTRate(e.target.value)} placeholder="0.00" />
            </div>
            <div className="pg-field">
              <label className="pg-label">HSN Code</label>
              <input className="pg-input" value={hsncode} onChange={e => setHSNCode(e.target.value)} placeholder="Enter HSN Code" />
            </div>
            <div className="pg-field">
              <label className="pg-checkbox-label">
                <input type="checkbox" checked={isExcluding} onChange={e => setIsExcluding(e.target.checked)} />
                Is Excluding
              </label>
            </div>
          </div>
        </div>
      </form>

      <div className="pg-watermark"><CopyrightIcon style={{ fontSize: 12 }} /><b>EFFTABS SOLUTIONS LLP</b></div>
    </div>
  );
};

export default ItemCreate;
